import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { CLINIC } from "../site/data";

const LINKS = [
  { label: "About", id: "about" },
  { label: "Approach", id: "approach" },
  { label: "Services", id: "services" },
  { label: "Aesthetics", id: "aesthetics" },
  { label: "FAQ", id: "faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-background/85 backdrop-blur-md border-b border-border" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1600px] px-6 md:px-10 h-20 flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("hero")} className="font-serif text-xl md:text-2xl tracking-tight text-foreground">
          Amar Sagoo Nursing Inc<span className="text-secondary">.</span>
        </button>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-contact-cta"
            onClick={() => go("contact")}
            className="bg-primary text-primary-foreground px-6 py-3 text-xs font-semibold uppercase tracking-[0.18em] hover:bg-secondary transition-colors duration-300"
          >
            Get Help
          </button>
        </div>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-foreground" onClick={() => setOpen((v) => !v)}>
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-background border-b border-border"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button key={l.id} data-testid={`nav-mobile-${l.id}`} onClick={() => go(l.id)} className="text-left text-sm uppercase tracking-[0.18em] text-muted-foreground">
                  {l.label}
                </button>
              ))}
              <button data-testid="nav-mobile-contact" onClick={() => go("contact")} className="bg-primary text-primary-foreground py-3 text-xs uppercase tracking-[0.18em]">
                Get Help — {CLINIC.phone}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
